export default function Refrigerator() {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_10719_12029)">
                <path
                    d="M22.5 3H9.5C8.67157 3 8 3.67157 8 4.5V27.5C8 28.3284 8.67157 29 9.5 29H22.5C23.3284 29 24 28.3284 24 27.5V4.5C24 3.67157 23.3284 3 22.5 3Z"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M8 14L24 14" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M11 8L11 11" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M11 17L11 20" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_10719_12029">
                    <rect width="32" height="32" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
